import { property as i } from "../beacon-property.d/index.js";
import { C as h } from "./cta-variant-SwPVCQO_.js";
import { T as v } from "./tracks-default-slot-BPn9RwTE.js";
import { b as p } from "./abstract-base-DlmRC3qm.js";
import { B as f } from "./beacon-primitive-ChVMWFlW.js";
import { c as y, a as g } from "./query-assigned-DZ4JAxBy.js";
import { B as w } from "./form-associated-L7I3gs1I.js";
import { i as u } from "./reactive-element-BDpydG15.js";
import "../beacon-html.d/index.js";
import "./lit-element-DC8UPTKS.js";
import { m as S } from "./lifecycle-decorators-CUsT9aHq.js";
var m = /* @__PURE__ */ ((t) => (t.LOADING = "loading", t.PROGRESS = "progress", t.SUCCESS = "success", t.RESULT = "result", t.NONE = "", t))(m || {}), d = /* @__PURE__ */ ((t) => (t.SUBMIT = "submit", t.BUTTON = "button", t.RESET = "reset", t.MENU = "menu", t))(d || {});
const O = u`[beacon-tag-name=beacon-button][icon-align=left]{--beacon-button-icon-align: start}.beacon-button-icon{align-self:var(--beacon-button-icon-align, center);block-size:var(--beacon-reference-space-5);inline-size:var(--beacon-reference-space-5)}.beacon-button-icon .beacon-button-icon--icon{fill:currentcolor}.beacon-button-icon .beacon-button-icon--stroke{stroke:currentcolor}.close-button-wrapper .beacon-button-icon{block-size:unset;inline-size:unset}[beacon-tag-name=beacon-icon-button] .beacon-button-icon{block-size:var(--override-icon-button-block-size, var(--beacon-reference-space-7, calc(1.5 * var(--beacon-unit-base))));inline-size:var(--override-icon-button-inline-size, var(--beacon-reference-space-7, calc(1.5 * var(--beacon-unit-base))))}`, x = u`:host([motion-state=enabled]) a,:host([motion-state=enabled]) button,:host([motion-state=enabled]) .icon-button{--button-base-transition-property: background-color;transition-duration:var(--button-base-transition-duration, 0s);transition-property:var(--button-base-transition-property);transition-timing-function:var(--button-base-transition-timing-function, var(--beacon-system-motion-easing-decelerate-emphasize-1))}:host([motion-state=enabled]) a .contents,:host([motion-state=enabled]) button .contents,:host([motion-state=enabled]) .icon-button .contents{transition-duration:inherit;transition-property:transform;transition-timing-function:inherit}`;
var E = Object.defineProperty, T = Object.getOwnPropertyDescriptor, k = (t, o, e, s) => {
  for (var r = s > 1 ? void 0 : s ? T(o, e) : o, c = t.length - 1, b; c >= 0; c--)
    (b = t[c]) && (r = (s ? b(o, e, r) : b(r)) || r);
  return s && r && E(o, e, r), r;
};
const B = () => function(o) {
  let e = class extends o {
    static get ButtonBaseMotionStyles() {
      return [x];
    }
  };
  return e = k([
    S("ButtonBaseMotion")
  ], e), e;
}, _ = u`:is(button,a):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}:is(button,a).tertiary:focus-visible{--second-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--second-ring-width) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus));outline-offset:0;position:relative;z-index:1}`;
var C = Object.defineProperty, a = (t, o, e, s) => {
  for (var r = void 0, c = t.length - 1, b; c >= 0; c--)
    (b = t[c]) && (r = b(o, e, r) || r);
  return r && C(o, e, r), r;
};
const l = {
  icon: "beacon-button-icon",
  strokeFill: "beacon-button-icon--stroke",
  iconFill: "beacon-button-icon--icon"
}, j = "stroke";
class n extends f(w, B(), v({ clean: !0 })) {
  constructor() {
    super(...arguments), this.focusOverride = !0, this.SLOTTED_ICON_INDEX = 0, this.type = d.BUTTON, this.variant = h.PRIMARY, this.state = m.NONE, this.disabled = !1, this.linkHref = "";
  }
  static get styles() {
    return [super.styles, _, this.ButtonBaseMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, O];
  }
  /**
   * Returns the first element in the icon slot
   */
  get icon() {
    return this.iconElements[this.SLOTTED_ICON_INDEX];
  }
  /**
   * Event listener for internal HTML button that
   * determines click behavior depending on its disabled state
   * and button type.
   * @param event click event
   * @event {BeaconEvents} beacon-event-click - Emits when clicked
   */
  handleClick(o) {
    this.disabled ? (o.preventDefault(), o.stopPropagation(), o.stopImmediatePropagation()) : (this.emitClick(o), this.internals && this.type === d.SUBMIT && this.internals.form.requestSubmit());
  }
  /**
   * Applies proper CSS class to slotted SVG such that it renders correctly
   * @param element reference to the slotted SVG
   */
  applySVGClass(o) {
    o && Array.from(o.children).forEach((e) => {
      if (e) {
        const s = e.getAttribute(j) ? l.strokeFill : l.iconFill;
        e.classList.add(s);
      }
    });
  }
  handleIconSlotchange() {
    var o;
    if (this.icon) {
      this.icon.classList.add(l.icon);
      const e = (o = this.label) != null ? o : this.defaultSlotText;
      p(this.icon, e), this.applySVGClass(this.icon);
    }
  }
}
a([
  i({ reflect: !0 })
], n.prototype, "type");
a([
  i({ alternateSlot: "default", sync: !1 })
], n.prototype, "label");
a([
  i()
], n.prototype, "variant");
a([
  i()
], n.prototype, "state");
a([
  i({ type: Boolean })
], n.prototype, "disabled");
a([
  i({ attribute: "link-href" })
], n.prototype, "linkHref");
a([
  i({ attribute: "link-download" })
], n.prototype, "linkDownload");
a([
  i({ attribute: "link-target" })
], n.prototype, "linkTarget");
a([
  y({ flatten: !0, slot: "icon", selector: "svg" })
], n.prototype, "iconElements");
a([
  g("button, a")
], n.prototype, "button");
export {
  n as B
};
